"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryAndSecondaryTripStatusTitle = exports.primaryAndSecondaryTripStatusDescription = exports.primaryAndSecondaryTripStatusAllKnown = void 0;
const Enum_1 = require("../type-descriptions/Enum");
const Color_1 = require("../type-descriptions/wave/Color");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const SecondaryTripStatus_1 = require("./SecondaryTripStatus");
const TripStatus_1 = require("./TripStatus");
exports.primaryAndSecondaryTripStatusAllKnown = [
    'REQUIRES_RESPONSE',
    'CREATED',
    'UNASSIGNED',
    'ASSIGNED',
    'SCHEDULED',
    'ACCEPTED',
    'ON_ROUTE_TO_PICKUP',
    'AT_PICKUP',
    'STARTED',
    'ON_ROUTE_TO_DROP_OFF',
    'AT_DROP_OFF',
    'COMPLETED',
    'TRIP-TIMED-OUT',
    'CANCELED-BY-RIDER',
    'CANCELED-BY-DRIVER',
    'UNKNOWN',
];
exports.primaryAndSecondaryTripStatusDescription = Object.assign(Object.assign({}, (0, Enum_1.enumDescription)({
    values: exports.primaryAndSecondaryTripStatusAllKnown,
    userFacingTitle: 'status + secondary status',
    userFacingValue: primaryAndSecondaryTripStatusTitle,
    order: status => exports.primaryAndSecondaryTripStatusAllKnown.indexOf(status),
})), { tableWidth: 'LG', userFacingValue: (_, trip) => {
        var _a;
        return `${(0, TripStatus_1.tripStatusAdminTitle)(trip.status)}${(_a = (0, unwrap_1.default)((0, SecondaryTripStatus_1.secondaryTripStatusForTrip)(trip), secondaryStatus => ` (${(0, SecondaryTripStatus_1.secondaryTripStatusTitle)(secondaryStatus)})`)) !== null && _a !== void 0 ? _a : ''}`;
    }, getValue: trip => { var _a; return (_a = (0, SecondaryTripStatus_1.secondaryTripStatusForTrip)(trip)) !== null && _a !== void 0 ? _a : trip.status; }, color: status => {
        switch (status) {
            case 'REQUIRES_RESPONSE':
                return Color_1.TAILWIND_COLORS.fuchsia[300];
            case 'CREATED':
                return Color_1.TAILWIND_COLORS.fuchsia[500];
            case 'UNASSIGNED':
                return Color_1.TAILWIND_COLORS.violet[200];
            case 'ASSIGNED':
                return Color_1.TAILWIND_COLORS.violet[400];
            case 'SCHEDULED':
                return Color_1.TAILWIND_COLORS.violet[600];
            case 'ACCEPTED':
                return Color_1.TAILWIND_COLORS.blue[300];
            case 'ON_ROUTE_TO_PICKUP':
                return Color_1.TAILWIND_COLORS.blue[500];
            case 'AT_PICKUP':
                return Color_1.TAILWIND_COLORS.blue[700];
            case 'STARTED':
                return Color_1.TAILWIND_COLORS.cyan[200];
            case 'ON_ROUTE_TO_DROP_OFF':
                return Color_1.TAILWIND_COLORS.cyan[400];
            case 'AT_DROP_OFF':
                return Color_1.TAILWIND_COLORS.cyan[600];
            case 'COMPLETED':
                return Color_1.TAILWIND_COLORS.emerald[400];
            case 'CANCELED-BY-DRIVER':
                return Color_1.TAILWIND_COLORS.red[600];
            case 'CANCELED-BY-RIDER':
                return Color_1.TAILWIND_COLORS.rose[600];
            case 'TRIP-TIMED-OUT':
                return Color_1.TAILWIND_COLORS.red[600];
            case 'UNKNOWN':
                return Color_1.TAILWIND_COLORS.zinc[400];
        }
    } });
function primaryAndSecondaryTripStatusTitle(status) {
    if (TripStatus_1.tripStatusAll.includes(status)) {
        return (0, TripStatus_1.tripStatusAdminTitle)(status);
    }
    else {
        return (0, SecondaryTripStatus_1.secondaryTripStatusTitle)(status);
    }
}
exports.primaryAndSecondaryTripStatusTitle = primaryAndSecondaryTripStatusTitle;
